<app-page-header *ngIf="!disableHeader" header="{{language.idl_header}}"
    backgroundPath="assets/images/lead/lead-calculate.jpg">
</app-page-header>
<ngx-ui-loader></ngx-ui-loader>
<section class="content-inner">
    <!-- First Investment Units -->
    <div class="first-investment">
        <div class="container">
            <section class="section _intro">
                <header>
                    <h2 class="topic-title">{{language.idl_sub_header}}</h2>
                </header>
            </section>
            <section class="content-detail">
                <div class="row">
                    <div rel="layout-detail"
                        style="box-shadow: 0 0 4px 0 rgb(0 0 0 / 9%);border-radius: 5px;background: white;">
                        <div class="info" style="width: 50%;margin-left: auto; margin-right: auto; padding-top: 10px;">
                            <table class="table" width="100%" style="text-align: center;">
                                <thead>
                                    <tr style="background-color: #395e77; color: #fff;">
                                        <th width="50%">Index Level Date</th>
                                        <th width="50%">Index Level</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let item of filterList">
                                        <td>{{item.IndexDate}}</td>
                                        <td>{{item.IndexValue}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="col-12">
                            <app-paginator [currentPage]="currentPage" [totalPage]="totalPage"
                                (currentPageNumber)="setCurrentPage($event)">
                            </app-paginator>
                        </div>
                        <!-- <div class="col-12"style="font-size: 12px;color: darkgrey;">
                            <p>LastUpdate {{lastUpdateStr}}</p>
                        </div> -->
                    </div>
                </div>
            </section>
            <br /><br />
            <section>
                <span class="desc">{{language.idl_dis_0}}</span> <br /><br />
                <span class="desc">{{language.idl_dis}}</span>
            </section>


        </div>
    </div>
</section>